<template>
  <div>
    <el-dialog
    :visible.sync="dialogVisible"
    width="30%"
    >
    <slot></slot>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t('other.a106')}}</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{$t('other.a279')}}</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
data(){
return{
    dialogVisible:false
}
},
created(){

},
methods:{

}
}

</script>
<style scoped>
</style>